import App from '@/AppManagement'
import router from '@/router/management'
import store from '@/store'
import init from '@/init'

const APP_ID = 'management'

init(APP_ID, App, router, store)
